import { BarDatum } from '../ProgressBar/ProgressBar';

const sortByProportionDesc = (data: BarDatum[]) => [...data].sort((a, b) => b.proportion - a.proportion);

export default sortByProportionDesc;
